import { useCallback, useMemo, useState } from "react";
import useDelay from "skin/entry/hook/delay";
import findAddress from "skin/entry/query/address";
import { capitalize } from "skin/entry/tool/string";

export default function useInn(data) {
	const arr = useMemo(() => {
		const legal = data.type === 'LEGAL';

		const inn = ['inn', 'ИНН', data.inn];
		const type = ['type', 'Тип', legal
			? 'Юридическое лицо'
			: 'Индивидуальный предприниматель'
		];
		const name = ['name', 'Наименование', data.offName];
		const ogrn = ['ogrn', 'ОГРН', data.ogrn];
		const manager = ['manager', capitalize(data.managerTitle), data.manager];
		const kpp = legal && ['kpp', 'КПП', data.kpp];
		
		const doc = [ inn, type, name, ogrn, kpp, manager ].filter(Boolean);
		if (legal) doc.push(['address', 'Адрес', data.address])

		return doc;
	}, [data]);

	const [address, setAddress] = useState();
	const [list, setList] = useState();
	const [wait, setWait] = useState(null);
	const [start] = useDelay();
	const onChange = useCallback(ev => {
		const value = ev.target.value;
		setAddress(value);
		wait?.abort?.();
		setWait('typing');
		function run() {
			if (!value) return;
			const ac = new AbortController();
			setWait(ac);
			findAddress(value, ac.signal)
			.then(setList)
			.catch(err => {
				console.error('err', err);
			})
			.finally(_ => setWait(null))
		};
		start(run, 1000, value);
	}, [wait]);
	return { arr, address, onChange, wait, list };
}